import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './site.css';

// Hash links (/#quiz) don't scroll on their own after a client-side route change.
function useScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
}

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}

const NAV = [
  ['/', 'Check a car', true],
  ['/compare-cars', 'Compare two cars'],
  ['/#quiz', 'Find your report'],
  ['/#reports', 'Report guide'],
  ['/how-we-work', 'How we work'],
];

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);
  const { pathname, hash } = useLocation();
  useScrollToHash();
  useEffect(() => setOpen(false), [pathname, hash]);

  return (
    <div className="cv">
      <header className="cv-header">
        <div className="cv-wrap cv-header-row">
          <Link to="/" className="cv-logo" aria-label="CompareVIN home">
            <img src="/logo-header.png" alt="CompareVIN" />
          </Link>
          <button className="cv-menu-btn" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
            {open ? 'Close' : 'Menu'}
          </button>
          <nav className={`cv-nav${open ? ' open' : ''}`} aria-label="Main">
            {NAV.map(([to, label, end]) =>
              to.includes('#') ? (
                <Link key={to} to={to}>{label}</Link>
              ) : (
                <NavLink key={to} to={to} end={end}>{label}</NavLink>
              )
            )}
          </nav>
        </div>
      </header>
      <main>{children}</main>
      <footer className="cv-footer">
        <div className="cv-wrap">
          <div className="cv-footer-grid">
            <div className="cv-footer-brand">
              <div className="name">CompareVIN</div>
              <p>Free vehicle safety data from NHTSA, and an honest guide to which history report is worth paying for. Not affiliated with Carfax, AutoCheck, NHTSA or NICB.</p>
              <p style={{ marginTop: 12 }}>Some links are affiliate links — we may earn a commission if you buy, at no extra cost to you. <Link to="/how-we-work">How we work</Link>.</p>
            </div>
            <div className="cv-footer-cols">
              <div className="cv-footer-col">
                <h4>Tools</h4>
                <Link to="/">Check a car</Link>
                <Link to="/compare-cars">Compare two cars</Link>
                <Link to="/#quiz">Report finder</Link>
              </div>
              <div className="cv-footer-col">
                <h4>Guides</h4>
                <Link to="/#reports">History report guide</Link>
                <Link to="/#faq">FAQ</Link>
              </div>
              <div className="cv-footer-col">
                <h4>For providers</h4>
                <Link to="/get-listed">Get listed</Link>
                <Link to="/how-we-work">How we choose</Link>
              </div>
              <div className="cv-footer-col">
                <h4>About</h4>
                <Link to="/how-we-work">How we work</Link>
                <Link to="/privacy">Privacy</Link>
                <a href="mailto:support@comparevin.com">Contact</a>
              </div>
            </div>
          </div>
          <div className="cv-footer-bottom">
            <span>© {new Date().getFullYear()} CompareVIN</span>
            <span>Recall, complaint and crash-test data: NHTSA (public domain)</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
